import BaseComponent from '@/components/base';
import VQBGateway from '@/gateway/VQB';
import { FontStyle } from '@/components/style';
import { StyleCta } from '@/components/style/style-cta';

export default class ResultsPage extends BaseComponent {
  errors;

  render() {
    return `
      ${FontStyle}
      ${StyleCta}
      <style>
        .page-my-results {
            display: flex;
            flex-direction: column;
        }
        .results-title {
            max-width: 900px;
        }

        .results-eyebrow {
            margin-bottom: 24px;
        }
      </style>
      <div class="page-my-results">
        <slot></slot>
      </div>
    `;
  }
  async onConnect() {
    const urlParams = new URLSearchParams(window.location.search);
    var _learnq = window._learnq || [];

    const quizConfig = {
      results: urlParams.get('results'),
      profile_type: urlParams.get('profile_type'),
      profile_email: urlParams.get('profile_email'),
      recommended_products: urlParams.get('recommended_products'),
      chemicalDamage: urlParams.get('chemical_damage'),
      heatDamage: urlParams.get('heat_damage'),
      mechanicalDamage: urlParams.get('mechanical_damage'),
      finalDamage: urlParams.get('final_damage'),
      product_type: urlParams.get('product_type'),
      explore_more_products: urlParams.get('product_type'),
      email: urlParams.get('product_type')
    };

    const damageLevelEvent = {
      Customer_Email: urlParams.get('profile_email'),
      Chemical: urlParams.get('chemical_damage'),
      Heat: urlParams.get('heat_damage'),
      Mechanical: urlParams.get('mechanical_damage'),
      Overrall_Damage_Level: urlParams.get('final_damage')
    };

    _learnq.push(['track', 'Damage Level', damageLevelEvent]);

    const current = `${window.location.href}`;
    const next = current.replace('pages/my-results', 'collections/regimen');

    const continueToRegimenButton = document.getElementById(
      'continueToRegimenButton'
    );
    continueToRegimenButton.addEventListener('click', () => {
      window.location.href = next;
    });

    this.errors = [];

    const quizData = await VQBGateway.getFormattedQuizData();

    if (!quizData.success) {
      this.errors.push(quizData.message);
      // return;
    }

    if (quizData.success) {
      const quizDataFormatted = quizData.data.quiz_responses_with_tag
        .map((item) => {
          if (item.answers) {
            return item.answers.map((answer) => ({
              kl_question_tag: item.kl_question_tag,
              answer: answer.answer
            }));
          }
          return {
            kl_question_tag: item.kl_question_tag,
            answer: item.answer
          };
        })
        .flat();

      function getAnswersByTag(array, tag) {
        // Lista para armazenar as respostas encontradas
        const answers = [];

        // Percorre o array procurando pela tag especificada
        array.forEach((item) => {
          if (item.kl_question_tag === tag) {
            answers.push(item.answer);
          }
        });

        return answers.join();
      }
      const identifyObject = {
        'profile_hair_color-or-treat': getAnswersByTag(
          quizDataFormatted,
          '__color_treatment'
        ),
        profile_hair_color: getAnswersByTag(quizDataFormatted, '__hair_color'),
        profile_hair_formula_name: quizData.data.user_name,
        profile_hair_goals: getAnswersByTag(quizDataFormatted, '__hair_goals'),
        profile_hair_moisture: getAnswersByTag(
          quizDataFormatted,
          '__scalp_moisture'
        ),
        profile_hair_structure: getAnswersByTag(
          quizDataFormatted,
          '__hair_structure'
        ),
        profile_hair_styling: getAnswersByTag(quizDataFormatted, '__styling'),
        profile_hair_styling_goals: getAnswersByTag(
          quizDataFormatted,
          '__hair_goals'
        ),
        profile_hair_type: getAnswersByTag(quizDataFormatted, '__hair_type'),
        profile_hair_styling_often: getAnswersByTag(
          quizDataFormatted,
          '__styling_frequency'
        ),
        'profile_hair_color-or-treat_often': getAnswersByTag(
          quizDataFormatted,
          '__color_treatment_frequency'
        ),
        profile_age: getAnswersByTag(quizDataFormatted, '__age'),
        profile_hair_brassiness: getAnswersByTag(
          quizDataFormatted,
          '__anti_brassiness'
        ),
        profile_hair_styling_level: getAnswersByTag(
          quizDataFormatted,
          '__hold_strength'
        )
      };
      for (let key in identifyObject) {
        if (identifyObject[key] === '') {
          delete identifyObject[key];
        }
      }
      _learnq.push(['identify', identifyObject]);
    }
    document
      .querySelector('score-banner')
      ?.setAttribute(
        'quiz-data',
        JSON.stringify(
          quizData?.data?.quiz_responses_with_tag
            ? quizData.data.quiz_responses_with_tag.find(
                (response) => response.question === '__hair_goals'
              )
            : []
        )
      );

    const resultsBanner = this.querySelector('results-banner');

    resultsBanner.querySelector('.profile_name').innerText =
      `${quizData?.data?.user_name}`;

    const scoreBanner = resultsBanner.querySelector('score-banner');

    const getPercentage = (level) => {
      if (level === '1') return '33';

      if (level === '2') return '66';

      if (level === '3') return '95';

      return '33';
    };

    scoreBanner.setAttribute(
      'chemical',
      quizConfig.chemicalDamage
        ? `${getPercentage(quizConfig.chemicalDamage)}`
        : '33'
    );
    scoreBanner.setAttribute(
      'heat',
      quizConfig.heatDamage ? `${getPercentage(quizConfig.heatDamage)}` : '33'
    );
    scoreBanner.setAttribute(
      'mechanical',
      quizConfig.mechanicalDamage
        ? `${getPercentage(quizConfig.mechanicalDamage)}`
        : '33'
    );

    scoreBanner.setAttribute('description-type', quizConfig.product_type);

    localStorage.setItem('fobQuizData', JSON.stringify(quizData));

    document.querySelector('loading-modal').enabled = false;
    const resultsElement = document.querySelector('results-page');
    resultsElement.style.display = 'initial';
  }
}
